<template>
	<Question :demo="demo">
		<template v-slot:question>
			Votre établissement est-il implanté dans un département qui était sous couvre-feu en <u>octobre 2020</u> ?
		</template>

		<template v-slot:aide>
			Si vous ne savez pas, vous pouvez consulter <a href="https://www.data.gouv.fr/fr/datasets/departements-de-metropole-concernes-par-le-couvre-feu-sanitaire-du-23-10-2020-1/" target="_blank" >la liste des départements concernés</a>.
		</template>

		<template v-slot:input>
			<b-field>
				<b-radio
					v-model="couvreFeuOctobre"
					native-value="oui"
					:disabled="demo"
				>
					Oui
				</b-radio>
			</b-field>
			<b-field>
				<b-radio
					v-model="couvreFeuOctobre"
					native-value="non"
					:disabled="demo"
				>
					Non
				</b-radio>
			</b-field>
		</template>
	</Question>
</template>

<script>
import Question from '@/components/Question.template.vue'

export default {
	components: {
		Question,
	},

	name: 'QCouvreFeu',

	props: {
		demo: Boolean,
	},

	computed: {
		couvreFeuOctobre: {
			get () {
				return this.$store.state.m2.couvreFeuOctobre
			},
			set (couvreFeuOctobre) {
				this.$store.commit('m2/setCouvreFeuOctobre', couvreFeuOctobre)
			}
		},
	},
}
</script>

<style scoped>

</style>
